import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "credit-card",
  "use": "credit-card-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"credit-card\"><g fill-opacity=\".5\"><path d=\"M2 5.753c0-.967.784-1.75 1.75-1.75h16.495c.964 0 1.748.78 1.75 1.746l.001 3.304V12H19.25A2.25 2.25 0 0017 14.25V15h-.75A2.25 2.25 0 0014 17.25v2.746H3.75A1.75 1.75 0 012 18.246V10.5h19.996V9H2V5.753z\" /><path d=\"M20 14.25a.75.75 0 00-1.5 0v2.25h-2.25a.75.75 0 000 1.5h2.25v2.25a.75.75 0 001.5 0V18h2.25a.75.75 0 000-1.5H20v-2.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol